import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ConfigurationService } from '~common/configuration/configuration.service';
import { Lookups, Segment, Location } from '~models/traveldoc';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FocusNextBase } from '~common/components/base/focusnextbase';
import { CustomValidators } from '~common/validators/custom-validators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'one-way',
  templateUrl: './one-way.component.html',
  styleUrls: ['./one-way.component.scss']
})

export class OneWayComponent extends FocusNextBase implements OnInit {
  form: UntypedFormGroup;
  lookups: Lookups;
  
  @Input() parentForm: UntypedFormGroup;
  @Input() segments: Array<Segment>;
  @ViewChild('departureDate', { static: false }) departureDate;
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;
  @Output() originChanged: EventEmitter<Location> = new EventEmitter<Location>();

  readonly ctrl_departureDate: string = "departureDate";
  readonly ctrl_departureLocation: string = "departureLocation";
  readonly ctrl_arrivalLocation: string = "arrivalLocaiton";
  public readonly minDate: Date;
  public readonly maxDate: Date;

  get controls() { return this.form.controls; }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private cd: ChangeDetectorRef) {
    super();
    this.lookups = this.configurationService.configuration.lookups;
    this.minDate = configurationService.configuration.minDate;
    this.maxDate = configurationService.configuration.maxDate;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      departureLocation: ['', CustomValidators.objectSelectedValidator],
      arrivalLocaiton: ['', CustomValidators.objectSelectedValidator],
    });

    this.form.addControl('departureDate', new UntypedFormControl(moment(this.segments[0].departureDate), CustomValidators.objectSelectedValidator));
    this.controls[this.ctrl_departureDate].valueChanges.subscribe((value: moment.Moment) => {
      if (typeof value !== "string") {
        this.segments[0].departureDate = value;
      }
      //if (this.departureDate) {
      //  this.focusNext(this.departureDate.nativeElement);
      //}
    });

    this.controls[this.ctrl_departureLocation].valueChanges.subscribe((value: Location) => {
      if (typeof value !== "string") {
        if (this.originChanged) {
          this.originChanged.emit(value);
        }
        this.segments[0].origin = value;
        if (this.segments.length > 1) {
          this.segments[1].destination = value;
        }
      }
    });

    this.controls[this.ctrl_arrivalLocation].valueChanges.subscribe((value: Location) => {
      if (typeof value !== "string") {
        if (this.segments.length > 1) {
          this.segments[1].origin = value;
        }
        this.segments[0].destination = value;
      }
    });
    this.cd.detectChanges();
  }

}
